export const FACILITY = {
  name: "Next Level Development",
  street: "11630 W 85th St",
  cityLine: "Overland Park, KS 66214",
};
export const FACILITY_ADDRESS = `${FACILITY.street}, ${FACILITY.cityLine}`;
export const DIRECTIONS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${FACILITY.name}, ${FACILITY_ADDRESS}`)}`;

// Full display line for an offering's location; adds the street address for our facility.
export const locationLine = (loc) =>
  !loc || loc.trim().toLowerCase().startsWith(FACILITY.name.toLowerCase()) ? `${FACILITY.name}, ${FACILITY_ADDRESS}` : loc;
